import React from "react";
import styled from "styled-components";

import { materialAlbedo } from "../constants";
import { CustomInput, CustomButton } from "./Custom";

const CellPropsFormWrapper = styled.div`
  box-sizing: border-box;
  padding: 1rem;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
`;

const SectionWrapper = styled.div`
  box-sizing: border-box;
  padding: 0.5rem;
  max-width: 400px;
  text-align: left;
`;

const MaterialItemWrapper = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr;
  grid-gap: 1rem;
  max-width: 400px;
  justify-items: center;
  align-items: center;
  padding: 0.5rem;
  background-color: ${(props) =>
    props.heading ? "palevioletred" : "rgb(255, 229, 229)"};
`;

const MaterialSelectWrapper = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 3fr 1fr 2fr;
  grid-gap: 1rem;
  max-width: 400px;
  justify-items: center;
  align-items: center;
  padding: 0.5rem;
  background-color: ${(props) =>
    props.heading ? "palevioletred" : "rgb(255, 229, 229)"};
`;

const HeightSetterWrapper = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 1rem;
  max-width: 400px;
  justify-items: center;
  align-items: center;
  padding: 0.5rem;
  background-color: ${(props) =>
    props.heading ? "palevioletred" : "rgb(255, 229, 229)"};
`;

const Calc = ({
  cellId,
  dispatchCellProps,
  cellMats,
  cellHeight,
  closeDialog,
}) => {
  const dispatchMaterials = (materialName, materialFraction) => {
    dispatchCellProps({
      type: "ADD_MATERIAL",
      payload: {
        cellId,
        material: materialName,
        fraction: parseFloat(materialFraction),
      },
    });
  };

  const dispatchHeight = (e) => {
    dispatchCellProps({
      type: "SET_HEIGHT",
      payload: {
        cellId,
        height: parseFloat(e.target.value),
      },
    });
  };

  const handleSubmit = () => {
    closeDialog();
  };

  return (
    <CellPropsFormWrapper>
      <SectionWrapper>
        <HeightSetter cellHeight={cellHeight} dispatchHeight={dispatchHeight} />
      </SectionWrapper>
      <SectionWrapper>
        <MaterialSelect dispatchMaterials={dispatchMaterials} />
      </SectionWrapper>
      <SectionWrapper>
        <MaterialItemWrapper heading key="material-list-heading">
          <span>Material</span>
          <span>Fraction</span>
          <span> </span>
        </MaterialItemWrapper>
        {Object.getOwnPropertyNames(cellMats).map((material) => (
          <MaterialItemWrapper key={material}>
            <span>{material}</span>
            <span>{cellMats[material]}</span>
            <div>X</div>
          </MaterialItemWrapper>
        ))}
      </SectionWrapper>
      <SectionWrapper>
        <CustomButton onClick={handleSubmit}>Save</CustomButton>
      </SectionWrapper>
    </CellPropsFormWrapper>
  );
};

const MaterialSelect = ({ dispatchMaterials }) => {
  const [materialName, setMaterialName] = React.useState("---");
  const [materialFraction, setMaterialFraction] = React.useState(0);

  const setCellMaterial = (materialName, materialFraction) => {
    dispatchMaterials(materialName, materialFraction);
    setMaterialName("---");
    setMaterialFraction(0);
  };

  return (
    <MaterialSelectWrapper>
      <select
        onChange={(e) => setMaterialName(e.target.value)}
        name="material-selector"
        id="material-selector">
        <option value="---">---</option>
        {Object.getOwnPropertyNames(materialAlbedo.Direct).map((material) => (
          <option key={`material-${material}`} value={material}>
            {material}
          </option>
        ))}
      </select>
      <CustomInput
        value={materialFraction}
        onChange={(e) => setMaterialFraction(e.target.value)}
      />
      <CustomButton
        onClick={(e) => {
          e.preventDefault();
          setCellMaterial(materialName, materialFraction);
        }}>
        Add material
      </CustomButton>
    </MaterialSelectWrapper>
  );
};

const HeightSetter = ({ cellHeight, dispatchHeight }) => {
  return (
    <HeightSetterWrapper>
      <label htmlFor="height-input">Cell height (In metres)</label>
      <CustomInput
        value={cellHeight}
        onChange={dispatchHeight}
        type="text"
        placeholder="In metres"
      />
    </HeightSetterWrapper>
  );
};

export default Calc;
